import { Component, Input, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Restaurant } from '../../../core/models';
import { ConfigService } from '../../../core/services/config.service';
import { RestaurantService } from '../../../core/services/restaurant.service';
import { PhoneNumberPipe } from "../../../core/pipes/phone-number.pipe";
import { LocationMapComponent } from "../../../common/location-map/location-map.component";
import { BackButtonComponent } from "../common/back-button/back-button.component";
import { AddressPipe } from "../../../core/pipes/address.pipe";

@Component({
    selector: 'app-about-v2',
    standalone: true,
    imports: [
        TranslocoPipe,
        PhoneNumberPipe,
        LocationMapComponent,
        BackButtonComponent,
        AddressPipe
    ],
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],

})
export class AboutComponent implements OnInit {

    @Input() restaurant: Restaurant

    radiusCircleVisible: boolean = false
    zoom: number = 15

    constructor(
        public configService: ConfigService,
        public restaurantService: RestaurantService,
        public translate: TranslocoService) { }

    ngOnInit(): void {
    }

    toggleDeliveryRadiusClick() {
        if (this.radiusCircleVisible) this.zoom = 15
        else this.zoom = 10

        this.radiusCircleVisible = !this.radiusCircleVisible
    }

    encodeURI(str: string) {
        return encodeURI(str);
    }
}
